'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--VkWithCircle';

var EntypoVkWithCircle = function EntypoVkWithCircle(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,0.4c-5.302,0-9.6,4.298-9.6,9.6s4.298,9.6,9.6,9.6s9.6-4.298,9.6-9.6S15.302,0.4,10,0.4z M13.692,11.231c0,0,0.849,0.838,1.058,1.227c0.006,0.008,0.009,0.016,0.011,0.02c0.085,0.143,0.105,0.254,0.063,0.337c-0.07,0.138-0.31,0.206-0.392,0.212c0,0-1.458,0-1.5,0c-0.104,0-0.322-0.027-0.586-0.209c-0.203-0.142-0.403-0.375-0.598-0.602c-0.291-0.338-0.543-0.63-0.797-0.63c-0.032,0-0.065,0.005-0.095,0.015c-0.192,0.062-0.438,0.336-0.438,1.066c0,0.228-0.18,0.359-0.307,0.359c0,0-0.655,0-0.687,0c-0.234,0-1.453-0.082-2.533-1.221C5.569,10.41,4.379,7.612,4.369,7.586c-0.075-0.181,0.08-0.278,0.249-0.278h1.515c0.202,0,0.268,0.123,0.314,0.232c0.054,0.127,0.252,0.632,0.577,1.2c0.527,0.926,0.85,1.302,1.109,1.302c0.049,0,0.094-0.013,0.139-0.036c0.338-0.188,0.275-1.393,0.26-1.643c0-0.047-0.001-0.539-0.174-0.775C8.234,7.417,8.023,7.352,7.895,7.328c0.033-0.049,0.107-0.124,0.199-0.169c0.232-0.116,0.65-0.133,1.065-0.133h0.231c0.45,0.006,0.566,0.035,0.729,0.076c0.33,0.079,0.337,0.292,0.308,1.021c-0.009,0.207-0.018,0.441-0.018,0.717c0,0.06-0.003,0.124-0.003,0.192c-0.01,0.371-0.022,0.792,0.24,0.965c0.034,0.021,0.073,0.033,0.114,0.033c0.091,0,0.365,0,1.107-1.273c0.325-0.562,0.577-1.225,0.595-1.274c0.015-0.026,0.059-0.106,0.111-0.137c0.041-0.024,0.096-0.029,0.124-0.029h1.781c0.194,0,0.327,0.029,0.352,0.104c0.044,0.119-0.008,0.482-0.821,1.583c-0.137,0.182-0.258,0.341-0.363,0.479C12.909,10.449,12.909,10.498,13.692,11.231z' })
    );
};

exports.default = EntypoVkWithCircle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-entypo-icons/lib/entypo/VkWithCircle.js
// module id = 7585
// module chunks = 0